/** The collapsed company row's transaction position (nine-point round,
 *  point 2): how many entries are already matched, and how many decisions
 *  wait on a person — stated per row so 244 companies triage without
 *  opening a card. The counts are the server's cheap ones; offers and
 *  contested choices refine when the card opens and the search runs.
 */

const fmt = new Intl.NumberFormat('en-IN')

interface Position {
  matched_n?: number
  needs_you?: number
  needs_parts?: Record<string, number>
}

export function matchedChip(c: Position): string | null {
  const n = c.matched_n ?? 0
  if (n <= 0) return null
  return `${fmt.format(n)} matched`
}

/** Known parts, in display order, with their honest singular/plural. A part
 *  this build has never heard of still counts in the label (the server's own
 *  sum) — it just has no sentence yet. */
const PARTS: [key: string, one: string, many: string][] = [
  ['pending_review', 'awaiting a checker', 'awaiting a checker'],
  ['repeats', 'identical repeat', 'identical repeats'],
  ['weak_checks', 'matched on amount alone — check', 'matched on amount alone — check'],
]

export function needsYouChip(
  c: Position,
): { label: string; title: string } | null {
  const n = c.needs_you ?? 0
  if (n <= 0) return null
  const parts = c.needs_parts ?? {}
  const bits = PARTS.filter(([k]) => (parts[k] ?? 0) > 0).map(
    ([k, one, many]) => `${fmt.format(parts[k])} ${parts[k] === 1 ? one : many}`,
  )
  return { label: `${fmt.format(n)} for you`, title: bits.join(' · ') }
}
